module.exports = __webpack_public_path__ + "assets/smart-asset-instagram-icon.434389a9.svg";